
import {computed, defineComponent} from "vue";
import {useStore} from "@/store";
export default defineComponent({
  name: 'ProjetosVue',
  data () {
    return {
      nomeDoProjeto: '',
    }
  },

  methods: {
    salvar () {
      this.store.commit('ADICIONA_PROJETO', this.nomeDoProjeto)
      this.nomeDoProjeto = '';
    }
  },
  setup () {
    const store = useStore();
    return {
      store,
        projetos: computed(() => store.state.projetos)
    }
  }
})
